import { RouteRecordRaw } from 'vue-router';
import { LazyComponent } from '@/models/LazyComponent';

const Index: LazyComponent = () => import(/* webpackChunkName: "dividas" */ './views/index.vue');

const children: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: { path: '/dividas', replace: true },
  },
  {
    path: '/dividas',
    component: Index,
    meta: { showFooter: true },
  },
  {
    path: '/2-via-boleto/:credor',
    name: 'atalho-2-via-boleto',
    component: Index,
    meta: { showFooter: true },
  },
];

const component: LazyComponent = () => import(/* webpackChunkName: "home" */ '@/blocks/home/views/index.vue');

export { children, component };
